$(function () {
    var $form = $("#signupForm");

    if (!$form.length) {
        return;
    }

    $form.validate({
        rules: {
            name: { required: true, maxlength: 255 },
            email: {
                required: true,
                email: true,
                maxlength: 255,
                remote: {
                    type: "POST",
                    url: "/applications/check-email",
                    headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") }
                }
            },
            phone: { required: true, validPhone: true },
            country_code: { required: true },
            password: { required: true, minlength: 8 },
            password_confirmation: { required: true, equalTo: "#password" },
            terms: { required: true }
        },
        messages: {
            email: { remote: "An account with this email already exists. Sign in instead." },
            country_code: { required: "Please select your country." },
            phone: { required: "Please enter your phone number." },
            password_confirmation: { equalTo: "The two passwords do not match." },
            terms: { required: "Please accept the Terms of Service and Privacy Policy to continue." }
        },
        errorPlacement: function (error, element) {
            if (element.attr("type") === "checkbox") {
                error.insertAfter(element.closest(".form-check"));
            } else if (element.hasClass("select2-hidden-accessible")) {
                error.insertAfter(element.next(".select2"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            var $btn = $(form).find('button[type="submit"]');
            if ($btn.prop("disabled")) {
                return false;
            }
            $btn.prop("disabled", true).addClass("disabled");
            $("#phone_number").val($("#phone").intlTelInput("getNumber"));
            form.submit();
        }
    });

});
